import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import firebase from "./config/firebase";
import i18n from "./config/i18n";
import store from "./config/store";
import * as VueGoogleMaps from "vue2-google-maps";
import Buefy from "buefy";
import moment from "moment";
import MonthPicker from "vue-month-picker";
import VueToast from "vue-toast-notification";

require("./config/charts");
require("./style/app.scss");
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(Buefy);
Vue.prototype.moment = moment;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBbzlvfsAln3zAWftRLzferwAeHzv05al0",
    libraries: "places, geocode",
  },
});

Vue.use(VueToast);

Vue.use(MonthPicker);

let app;

function initialize() {
  app = new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");

  Vue.config.productionTip = false;
}

firebase.auth().onAuthStateChanged(function (user) {
  if (!app) {
    if (user) {
      store.dispatch("init", user).then(() => {
        initialize();
      });
    } else initialize();
  }
});
